import { render, staticRenderFns } from "./IssuedInvoicesList.vue?vue&type=template&id=51a72454&"
import script from "./IssuedInvoicesList.vue?vue&type=script&lang=js&"
export * from "./IssuedInvoicesList.vue?vue&type=script&lang=js&"
import style0 from "./IssuedInvoicesList.vue?vue&type=style&index=0&id=51a72454&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports